import React, { useState, useEffect } from 'react';
import { Block } from '@mui/icons-material';

import { LeanUser, BusinessOutlaw } from 'models';
import { consoleLogInDev, isNumber } from 'shared';
import { BasicDialog, IconButton } from 'library';
import { findOutlawed, findByBusinessId, findByBusinessName } from 'api/BusinessOutlawsApi';
import { BusinessSearch, UserInfo, BusinessList } from './ProviderOutlawModalComponents';
import { banHandler, unBanHandler } from './ProviderOutlawMethods';

export default function ProviderOutlawModal({
    user,
    onClose,
    defaultNameOrId,
}: {
    user: LeanUser;
    onClose?: () => void;
    defaultNameOrId?: string | number | null;
}) {
    const [open, setOpen] = useState<boolean>(false);
    const [memo, setMemo] = useState<string>('');
    const [outlawed, setOutlawed] = useState<BusinessOutlaw[]>([]);
    const [nameOrId, setNameOrId] = useState<string | number | null>(defaultNameOrId ?? null);

    useEffect(() => {
        if (open && user.id) {
            findOutlawed(user.id).then(setOutlawed).catch(consoleLogInDev);
        }
    }, [open, user.id]);

    useEffect(() => {
        if (defaultNameOrId && open && !outlawed.length) searchHandler();
    }, [open]);

    function searchHandler() {
        if (nameOrId === null) {
            findOutlawed(user.id).then(setOutlawed).catch(consoleLogInDev);
        } else if (isNumber(nameOrId)) {
            findByBusinessId(user.id, nameOrId as number)
                .then(setOutlawed)
                .catch(consoleLogInDev);
        } else if (nameOrId) {
            findByBusinessName(user.id, nameOrId as string)
                .then(setOutlawed)
                .catch(consoleLogInDev);
        }
        setMemo('');
    }

    function unBanProvider(businessOutlawId: number) {
        unBanHandler(businessOutlawId, outlawed, setOutlawed);
    }

    function banProvider(locationId: number, businessId: number) {
        function updateState(res: BusinessOutlaw[]) {
            setOutlawed(res);
            setMemo('');
        }
        banHandler(user.id, outlawed, locationId, businessId, updateState, memo);
    }

    return (
        <>
            <span style={{ marginLeft: 10 }}>
                <IconButton tooltip="Add to banned workers" icon={Block} onClick={() => setOpen(true)}></IconButton>
            </span>
            <BasicDialog
                dialogTitle={`Businesses Bans`}
                closeButton
                onClose={() => {
                    setOpen(false);
                    onClose?.();
                }}
                isOpen={open}
            >
                <BusinessSearch searchHandler={searchHandler} setNameOrId={setNameOrId} />
                <UserInfo user={user} outlawed={outlawed} />
                <BusinessList
                    outlawed={outlawed}
                    setMemo={setMemo}
                    banHandler={banProvider}
                    unBanHandler={unBanProvider}
                />
            </BasicDialog>
        </>
    );
}
